import {ProductCardWrapper} from './components/wrapper'

export const CardWrapper = ({
  children,
}: {
  children: JSX.Element | JSX.Element[]
}): JSX.Element => (
  <ProductCardWrapper recommended={false}>{children}</ProductCardWrapper>
)
